import { Stack, SxProps } from "@mui/material";

type MapPanelHeaderProps = {
    children: React.ReactNode;
    sx?: SxProps;
};

export function MapPanelHeader({ children, sx }: MapPanelHeaderProps) {
    return (
        <Stack
            direction="row"
            alignItems="center"
            paddingInline={2}
            paddingBlock={1}
            columnGap={1}
            flexShrink={0}
            sx={[
                theme => ({
                    borderRadius: 0.5,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    minHeight: 60,
                }),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            {children}
        </Stack>
    );
}
